const workStationsTable = {
  tableList: [
    {
      id: 1,
      text: "No",
      name: "sNo",
      visible: true,
      className: "text-center",
    },
    // {
    //   id: 2,
    //   text: "Id",
    //   name: "id",
    //   visible: true,
    //   className: null,
    // },
    {
      id: 3,
      text: "Unit Name",
      name: "unitname",
      visible: true,
      className: null,
    },
    {
      id: 4,
      text: "Workstation Name",
      name: "work_station_name",
      visible: true,
      className: null,
    },
    {
      id: 5,
      text: "cabin count",
      name: "cabin_count",
      visible: true,
      className: null,
    },
    {
      id: 6,
      text: "Tv Url",
      name: "tv_url",
      visible: true,
      className: null,
    },
    {
      id: 7,
      text: "Status",
      name: "status",
      visible: true,
      className: null,
    },
    {
      id: 8,
      text: "Action",
      name: "action",
      visible: true,
      className: null,
    },
  ],
};
const workStationsForm = {
  feilds: [
    {
      id: 0,
      name: "newWorkstation",
      text: "New Work Station",
      visible: true,
      element: "label",
      className: [],
      required: false,
    },
    {
      id: 1,
      name: "unit_id",
      text: "Select Unit Name",
      visible: true,
      element: "select2",
      required: true,
      input_type: "text",
      placeholder: "Select Unit Name",
      icon: "user",
      rules: [
        {
          test: (value) => {
            return value !== null;
          },
          message: "Please Enter Unit Name",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 2,
      name: "work_station_name",
      text: "Work Station Name",
      visible: true,
      element: "input",
      required: true,
      input_type: "text",
      placeholder: "Work Station Name",
      rules: [
        {
          test: (value) => {
            return value !== null && value.length > 0;
          },
          message: "Please Enter Work Station Name",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className: [],
    },
    {
      id: 3,
      name: "cabin_count",
      text: "Cabin Count",
      visible: true,
      element: "input",
      required: true,
      input_type: "number",
      placeholder: "Cabin Count",
      rules: [
        {
          test: (value) => {
            return (
              value !== null &&
              value.length > 0 &&
              value !== 0 &&
              value > 0 &&
              value !== undefined
            );
          },
          message: "Please Enter Cabin Count Number",
        },
      ],
      errors: [],
      value: null,
      valid: false,
      state: "",
      disable: false,
      className:[],
    },
    {
      name: "button",
      text: "Work Station",
      visible: true,
      required: false,
      element: "button",
      input_type: "button",
      disable: false,
    },
  ],
};

export { workStationsTable, workStationsForm };
